import initialState from './initialState'
import {FETCH_ETHNICITIES, RECEIVE_ETHNICITIES} from '../actions/actionTypes'

export default function ethnicities(state = initialState.ethnicities, action) {
	let newState
	switch (action.type) {
	case FETCH_ETHNICITIES:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_ETHNICITIES:
		newState = action.ethnicities
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ethnicities.js